var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"translate",rawName:"v-translate"}],staticClass:"btn btn-round ml-4",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.exportExcel()}}},[_vm._v("Exporter en xlsx")])}
var staticRenderFns = []

export { render, staticRenderFns }